import { SVGProps } from 'react';

const SvgUmbrellaBeach = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M399.7 18.8c1.3.5 2.6.9 4 1.4 4.1 1.5 8.1 3 12 4.7 103.7 43.7 164.6 148.9 155.7 256.9-1.6 19.2-21.5 30-39.6 23.4L349.7 239l-45.1-16.4-182.1-66.3c-18.1-6.6-26.4-27.7-15.3-43.4 64.2-90.8 182.8-132 292.6-94zM288.8 54.6C240.8 61 196.1 84.1 163 120l68.8 25c14.2-32.9 33.4-63.4 57-90.4zM413.3 211c9.4-32.5 13.2-66.4 11.2-100.2-1.1-18.2-12-34.2-28.2-41.9-3-1.2-6-2.4-9-3.5-1-.4-2-.7-2.9-1-18.2-5.9-38.3-.9-51.5 13.1-23.3 24.6-42.2 53.1-55.9 84L413.3 211zm45.2 16.4 65.5 23.9c-2.2-47-20.3-91.9-51-127.2.4 35-4.5 69.8-14.5 103.3zM552 464c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h192.7l76.9-211.4 45.1 16.4-71 195H552z" />
  </svg>
);
export default SvgUmbrellaBeach;
